import { Link } from 'react-router-dom';
import { PageHeader } from '../../components/primitives.jsx';
import {
  StaggerReveal,
  IconDashboard,
  IconBriefcase,
  IconRoadmap,
  IconHome,
} from '../../components/index.js';
import './errors.redesign.css';

const QUICK_LINKS = [
  {
    to: '/executive',
    label: 'Executive Command Center',
    desc: 'Mission pulse, predictive risk, and portfolio health.',
    Icon: IconDashboard,
  },
  {
    to: '/projects',
    label: 'Projects',
    desc: 'Delivery health, gate readiness, and work items.',
    Icon: IconBriefcase,
  },
  {
    to: '/roadmap',
    label: 'Strategic Roadmap',
    desc: 'Sequenced initiatives and milestone alignment.',
    Icon: IconRoadmap,
  },
  {
    to: '/home',
    label: 'Home',
    desc: 'Your persona landing and recent activity.',
    Icon: IconHome,
  },
];

export function NotFoundPage() {
  return (
    <>
      <PageHeader
        eyebrow="404"
        title="Not found"
        subtitle="That route is not part of the DHA PRIME shell."
      />

      <StaggerReveal className="glass-panel dark error-hero" data-testid="error-hero-404">
        <div className="error-hero__lede">
          <img
            className="error-hero__seal"
            src="/brand/dha-seal.svg"
            alt="Defense Health Agency seal"
            data-testid="error-dha-seal"
          />
          <div className="error-hero__heading">
            <span className="error-hero__eyebrow">Error 404</span>
            <h2 className="error-hero__title">This route isn&rsquo;t on the PRIME map</h2>
            <p className="error-hero__subtitle">
              The page you requested isn&rsquo;t part of the DHA PRIME shell. It may have moved,
              been renamed, or never existed. Use a command surface below to get back on mission.
            </p>
          </div>
        </div>

        <div className="banner amber" role="status" data-testid="error-banner">
          <span className="banner__icon" aria-hidden>
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <circle cx="12" cy="12" r="9" />
              <path d="M12 8v5" strokeLinecap="round" />
              <path d="M12 16.5h.01" strokeLinecap="round" />
            </svg>
          </span>
          <span className="banner__body">
            <span className="banner__title">No matching view</span>
            <span className="banner__detail">
              Nothing is mapped to this address. Pick a primary surface or restart from a persona.
            </span>
          </span>
        </div>

        <div className="error-hero__actions">
          <Link className="btn primary" to="/home">
            Go home
          </Link>
          <Link className="btn ghost" to="/login">
            Pick persona
          </Link>
        </div>
      </StaggerReveal>

      <section className="error-quicklinks" aria-label="Primary surfaces">
        <p className="error-quicklinks__title">Jump to a command surface</p>
        <StaggerReveal className="error-quicklink-grid">
          {QUICK_LINKS.map(({ to, label, desc, Icon }) => (
            <Link
              key={to}
              to={to}
              className="card interactive error-quicklink"
              data-testid={`error-quicklink-${to.replace(/\//g, '') || 'home'}`}
            >
              <span className="error-quicklink__icon" aria-hidden>
                <Icon />
              </span>
              <span className="error-quicklink__body">
                <span className="error-quicklink__label">{label}</span>
                <p className="error-quicklink__desc">{desc}</p>
              </span>
            </Link>
          ))}
        </StaggerReveal>
      </section>
    </>
  );
}
